import {
  format, startOfMonth, endOfMonth, subMonths, startOfQuarter, endOfQuarter,
  startOfYear, endOfYear, startOfWeek, endOfWeek, subYears,
} from "date-fns";

const fmt = (d) => format(d, "yyyy-MM-dd");

export const PERIOD_OPTIONS = [
  { key: "today", label: "Today" },
  { key: "this_week", label: "This Week" },
  { key: "this_month", label: "This Month" },
  { key: "last_month", label: "Last Month" },
  { key: "this_quarter", label: "This Quarter" },
  { key: "this_year", label: "This Year" },
  { key: "last_year", label: "Last Year" },
  { key: "all_time", label: "All Time" },
  { key: "custom", label: "Custom Range" },
];

export function getRange(key, custom) {
  const now = new Date();
  switch (key) {
    case "today": return { start: fmt(now), end: fmt(now) };
    case "this_week": return { start: fmt(startOfWeek(now)), end: fmt(endOfWeek(now)) };
    case "this_month": return { start: fmt(startOfMonth(now)), end: fmt(endOfMonth(now)) };
    case "last_month": { const d = subMonths(now, 1); return { start: fmt(startOfMonth(d)), end: fmt(endOfMonth(d)) }; }
    case "this_quarter": return { start: fmt(startOfQuarter(now)), end: fmt(endOfQuarter(now)) };
    case "this_year": return { start: fmt(startOfYear(now)), end: fmt(endOfYear(now)) };
    case "last_year": { const d = subYears(now, 1); return { start: fmt(startOfYear(d)), end: fmt(endOfYear(d)) }; }
    case "all_time": return { start: null, end: null };
    case "custom": return { start: custom?.start || null, end: custom?.end || null };
    default: return { start: fmt(startOfMonth(now)), end: fmt(endOfMonth(now)) };
  }
}

export function rangeParams(range) {
  const p = {};
  if (range.start) p.start = range.start;
  if (range.end) p.end = range.end;
  return p;
}

export function rangeLabel(key, range) {
  if (key === "all_time") return "All Time";
  const opt = PERIOD_OPTIONS.find((o) => o.key === key);
  const base = opt ? opt.label : "This Month";
  if (range.start && range.end) return `${formatShort(range.start)} – ${formatShort(range.end)}`;
  return base;
}

const formatShort = (d) => format(new Date(d), "dd MMM yyyy");
